export default "__VITE_ASSET__CYV2QfpM__"